import * as React from 'react';

import { Button, Modal, Grid } from 'antd';

const { useBreakpoint } = Grid;

interface ConfirmAddressProps {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  name: string;
}

const ConfirmUpdateAddress = ({ isOpen, setIsOpen, name }: ConfirmAddressProps) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width={isMobile ? '100vw' : 600}
      title='👍 Confirmação de endereço concluída!'
      closable
      footer={
        <div className='flex justify-end gap-2.5'>
          <Button onClick={handleClose} type='primary' size='large'>
            Fechar
          </Button>
        </div>
      }
    >
      <p className='text-text mb-5! text-base font-bold'>{name}</p>
      <div className='flex flex-col gap-3'>
        <p className='m-0!'>Seu endereço foi atualizado com sucesso. 👏</p>
        <p className='m-0!'>
          Agradecemos por nos informar sobre a mudança. Isso garante que seus mimos e reconhecimentos do Programa Elite
          sejam enviados para o local correto. <strong>Em breve, você receberá seus prêmios no novo endereço.</strong>
        </p>
        <p className='m-0!'>Parabéns por suas conquistas e obrigado por fazer parte do 🏆 Programa Elite!</p>
      </div>
    </Modal>
  );
};

export default ConfirmUpdateAddress;
